import React from 'react'
import './VerificationScn.css';
import { useState, useEffect } from 'react';
import { pdfjs } from 'react-pdf/dist/esm/entry.webpack5';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { faPlus, faSave, faCheckCircle, faTrashAlt, faTools, faTrash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { EditableSelect } from "react-editable-select";
import { useAppConfig } from '../../AppConfigProvider';
import PdfViewer from '../PdfViewer/PdfViewer';


const VerificationScn = ({ uId, setBillOCRDetails, BillOCRDetails, setBillItems, BillItems, handleDelete, addTableRows, onFormBillItemsValueChange, onFormVChange, isFileTypeImg, fullVendorsList, onVendorChange, isOCRVendor, OCRAddress, isNewVendor, load, setLoad, setIsImageUploaded, publish, setIsNewVendor, selectedOption, setSelectedOption, _onChange, selectedOptionAddress, setSelectedOptionAddress, _onChangeAddress, activeVendor, setActiveVendor, setFullVendorsList, activeVendorFull, setActiveVendorFull }) => {
    const appConfig = useAppConfig();
    let imgBill = appConfig.filesHost + BillOCRDetails.image;

    pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;



    const cancel = () => {
        setLoad(true);
        setTimeout(function () {
            setIsImageUploaded({ isImage: false, isOcr: false });
            setLoad(false);
        }, 1000);
    }

    const userIDD = uId;

    const saveConfig = () => {
        setLoad(true);
        if (isNewVendor) {
            console.log("is new supplier here bill ocr details", BillOCRDetails);
            const NewVendor = {
                vendorName: BillOCRDetails.vendorName,
                vendorAddress: BillOCRDetails.vendorAddress,
                vendorPhone: BillOCRDetails.vendorPhone,
                currency: BillOCRDetails.currency,
                userId: uId,
                isDeleted: false
            }
            axios.post(`${appConfig.backendUrl}api/v1/supplier`, NewVendor).then(function (response) {
                console.log("New Vendor response 111", NewVendor);
                console.log("New Vendor response", response.data);
                BillOCRDetails.vendorId = response.data.id;
                setBillOCRDetails(BillOCRDetails);
                axios.get(`${appConfig.backendUrl}api/v1/supplier/suppliers/${userIDD}`).then(function (response) {
                    setFullVendorsList(response.data);
                });
                setActiveVendor(NewVendor.vendorName);
                toast.success("Saved as new supplier", {
                    position: "top-right",
                    autoClose: 2000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "dark",
                })
                setLoad(false);
                setIsNewVendor(false);
            }).catch(err => {
                console.log(err);
                setLoad(false);
                toast.error(`${err.code}`, {
                    position: "top-right",
                    autoClose: 2000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "dark",
                });
            });
        }
        else {

            const OldVendorUpdate = {
                id: BillOCRDetails.vendorId,
                vendorName: BillOCRDetails.vendorName,
                vendorAddress: BillOCRDetails.vendorAddress,
                vendorPhone: BillOCRDetails.vendorPhone,
                currency: BillOCRDetails.currency,
                userId: uId,
                isDeleted: false
            }

            axios.put(`${appConfig.backendUrl}api/v1/supplier/updateSupplier`, OldVendorUpdate).then(function (response) {
                console.log("OLD Vendor response", OldVendorUpdate);
                console.log("Vendor Update response", response.data);
                axios.get(`${appConfig.backendUrl}api/v1/supplier/suppliers/${userIDD}`).then(function (response) {
                    setFullVendorsList(response.data);
                });
                setActiveVendor(OldVendorUpdate.vendorName);
                toast.success("Supplier Details Updated", {
                    position: "top-right",
                    autoClose: 2000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "dark",
                });
                setLoad(false);
            }).catch(err => {
                console.log(err);
                setLoad(false);
                toast.error(`${err.code}`, {
                    position: "top-right",
                    autoClose: 2000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "dark",
                });
            });
        }
    }

    function handleSubmit(event) {
        event.preventDefault()
        publish();
    }

    const [payableAccounts, setPayableAccounts] = useState([]);
    const [expenseAccounts, setExpenseAccounts] = useState([]);
    useEffect(() => {
        axios.get(`${appConfig.backendUrl}api/v1/qbuser/payable-accounts/${userIDD}`)
            .then(response => {
                setPayableAccounts(response.data)
                if (response.data && response.data.length > 0) {
                    setBillOCRDetails(bill => ({ ...bill, payableAccName: response.data[0].payableAccName }));
                }
                return axios.get(`${appConfig.backendUrl}api/v1/qbuser/expense-accounts/${userIDD}`);
            })
            .then(response => {
                setExpenseAccounts(response.data);
                setBillItems(currentItems => {
                    const updatedItems = currentItems.map(item => {
                        if (!item.hasOwnProperty('expenseAccountName') || item.expenseAccountName === '') {
                            const defaultAcc = (response.data && response.data.length > 0) ? response.data[0].expenseAccountName : '';
                            return { ...item, expenseAccountName: defaultAcc };
                        }
                        return item;
                    });
                    setBillOCRDetails(bill => ({ ...bill, billItems: updatedItems, userId: uId }));
                    return updatedItems;
                });
            })
            .catch(error => console.error('Error fetching payable-accounts:', error));
    }, [appConfig.backendUrl, setBillItems, setBillOCRDetails, userIDD, uId]);

    return (
        <div className='col-lg-12 px-c vr-scn'>

            {!load && <>
                <div className='row'>
                    <form className='BillForm col-lg-7' id="my-form" onSubmit={handleSubmit}>
                        <div className="mb-3 t-left" style={{ padding: '0 10px ' }}>
                            <label className="form-label sup-name">Supplier Name</label><br></br>
                            <select className="form-control" onChange={(e) => onVendorChange(e)} value={activeVendor || ''}>
                                <option value="" disabled>Select a supplier</option>
                                {fullVendorsList.map((item) => <option key={item.id || item.vendorName} value={item.vendorName}>{item.vendorName}</option>)}
                            </select>


                        </div>
                        <div className="row" style={{ padding: '0 10px ' }}>
                            <div className="col-12 col-md-6 mb-3 editable_select_wrap">
                                <label className="form-label">Name</label>
                                <EditableSelect
                                    name="input1"
                                    value={selectedOption}
                                    options={BillOCRDetails.vendorNameArray}
                                    getOptionValue={(o) => (o ? o : "")}
                                    getOptionLabel={(o) => (o ? o : "")}
                                    onChange={(ev, option) => _onChange(ev, option)}
                                    className="form-control"
                                />
                            </div>

                            <div className="col-12 col-md-6 mb-3 editable_select_wrap">
                                <label className="form-label">Address</label>
                                <EditableSelect
                                    name="input2"
                                    value={selectedOptionAddress}
                                    options={[...new Set(BillOCRDetails.vendorAddressList)]}
                                    getOptionValue={(o) => (o ? o : "")}
                                    getOptionLabel={(o) => (o ? o : "")}
                                    onChange={(ev, option) => _onChangeAddress(ev, option)}
                                    className="form-control"
                                />
                            </div>
                        </div>
                        <div className="row" style={{ padding: '0 10px ' }}>
                            <div className="col-12 col-md-6 mb-3">
                                <label className="form-label">Date</label>
                                <input type="date" className="form-control" name="invoiceDate" onChange={(e) => onFormVChange(e)} aria-describedby="emailHelp" defaultValue={BillOCRDetails.invoiceDate} required />
                            </div>
                            <div className="col-12 col-md-6 mb-3">
                                <label className="form-label">Due Date</label><br></br>
                                <input type="date" className="form-control" name="dueDate" aria-describedby="emailHelp" onChange={(e) => onFormVChange(e)} defaultValue={BillOCRDetails.dueDate} required />
                            </div>
                        </div>
                        <div className="row" style={{ padding: '0 10px ' }}>
                            <div className="col-12 col-md-6 mb-3">
                                <label className="form-label">Total</label>
                                <input type="number" step="0.01" className="form-control" name="totalAmount" onChange={(e) => onFormVChange(e)} aria-describedby="emailHelp" defaultValue={BillOCRDetails.totalAmount} />
                            </div>
                            <div className="col-12 col-md-6 mb-3">
                                <label className="form-label">Reference Number</label>
                                <input type="text" className="form-control" name="invoiceNo" aria-describedby="emailHelp" onChange={(e) => onFormVChange(e)} defaultValue={BillOCRDetails.invoiceNo} required />
                            </div>
                        </div>
                        <div className='row' style={{ padding: '0 10px ' }}>
                            <div className="col-12 col-md-6 mb-3">
                                <label className="form-label">Payable Account</label>
                                <select className="form-select form-control" name="payableAccName" onChange={(e) => onFormVChange(e)} value={BillOCRDetails.payableAccName || ''} required>
                                    <option value="" disabled>Select an account</option>
                                    {payableAccounts.map(account => (
                                        <option key={account.id} value={account.payableAccName}>{account.payableAccName}</option>
                                    ))}
                                </select>
                            </div>
                        </div>
                        {/* <div className="row pr-0">
            
            <div className="col">
                <label  className="form-label">Reference Number</label>
                <input type="text"  className="form-control" name="invoiceNo" aria-describedby="emailHelp" onChange={(e)=>onFormVChange(e)} defaultValue={BillOCRDetails.invoiceNo} />
            </div>
        </div> */}
                        <br></br>
                        <table className='billItemsTable'>
                            <thead>
                                <tr>
                                    <th>Item</th>
                                    <th>Des.</th>
                                    <th>Qty</th>
                                    <th>Unit Price</th>
                                    <th>Amount</th>
                                    <th>Expense Acc</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody className='t-left'>
                                {BillItems.map((item, index) => {
                                    return <tr key={item.itemNo}>
                                        <td>
                                            <div className="">
                                                <input type="text" className="form-control" id="itemName" aria-describedby="emailHelp" onChange={(e) => onFormBillItemsValueChange(e, item)} defaultValue={item.itemName} required />
                                            </div>
                                        </td>
                                        <td>
                                            <div className="">
                                                <input type="text" className="form-control" id="productCode" aria-describedby="emailHelp" onChange={(e) => onFormBillItemsValueChange(e, item)} defaultValue={item.productCode} required />
                                            </div>
                                        </td>
                                        <td>
                                            <div className="">
                                                <input type="number" className="form-control" id="quantity" aria-describedby="emailHelp" onChange={(e) => onFormBillItemsValueChange(e, item)} defaultValue={item.quantity} required />
                                            </div>
                                        </td>
                                        <td>
                                            <div className="">
                                                <input type="number" step="0.01" className="form-control" id="unitPrice" aria-describedby="emailHelp" onChange={(e) => onFormBillItemsValueChange(e, item)} defaultValue={item.unitPrice} required />
                                            </div>
                                        </td>
                                        <td>
                                            <div className="">
                                                <input type="number" step="0.01" className="form-control" id="price" aria-describedby="emailHelp" onChange={(e) => onFormBillItemsValueChange(e, item)} defaultValue={item.price} required />
                                            </div>
                                        </td>
                                        <td>
                                            <div className="">
                                                {(item.itemName !== "VAT" || (item.itemName === "VAT" && !BillOCRDetails.isTaxRegistered)) &&
                                                    <select className="form-select form-control" id="expenseAccountName" onChange={(e) => onFormBillItemsValueChange(e, item)} value={item.expenseAccountName || ''} required>
                                                        <option value="" disabled>Select an account</option>
                                                        {expenseAccounts.map(account => (
                                                            <option key={account.id} value={account.expenseAccountName}>{account.expenseAccountName}</option>
                                                        ))}
                                                    </select>
                                                }
                                                {
                                                    (item.itemName === "VAT" && BillOCRDetails.isTaxRegistered) &&
                                                    <select className="form-select form-control" id="expenseAccountName" onChange={(e) => onFormBillItemsValueChange(e, item)} value={item.expenseAccountName || ''} required disabled>
                                                        <option value={item.expenseAccountName}>{item.expenseAccountName}</option>
                                                    </select>
                                                }
                                            </div>
                                        </td>
                                        <td>
                                            <div className="d-flex justify-content-center">
                                                <button
                                                    type="button"
                                                    className='btn-bg-n text-danger'
                                                    onClick={() => handleDelete(item.itemNo)}
                                                    title="Delete line item"
                                                >
                                                    <FontAwesomeIcon icon={faTrash} />
                                                </button>
                                            </div>
                                        </td>
                                    </tr>

                                })}
                                {/* <ItemTableRows/> */}
                                <tr>
                                    <td colSpan="7">
                                        <button className="btn btn-add-item" onClick={addTableRows}><FontAwesomeIcon icon={faPlus} /> Add Line Item</button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </form>
                    <div className='col-lg-5 invoice-container'>
                        {/* <img src={imgBill} alt='ad' className='billImage'/>  */}
                        {
                            isFileTypeImg ?
                                <img src={imgBill} alt="invoice" className='billImage' />
                                : <div className="w-100 h-100 align-self-stretch" style={{ minHeight: '600px' }}><PdfViewer fileURL={imgBill} /></div>
                        }

                        <br></br>
                        <div className="action-bar">
                            <button type="submit" form="my-form" className="btn b1" title="Save this invoice to the system">
                                <FontAwesomeIcon icon={faCheckCircle} /> Save Invoice
                            </button>
                            <button type="button" onClick={saveConfig} className="btn b2" title="Save vendor configuration">
                                <FontAwesomeIcon icon={faSave} /> Save Config
                            </button>
                            <button type="button" onClick={cancel} className="btn b3" title="Discard these details">
                                <FontAwesomeIcon icon={faTrashAlt} /> Delete
                            </button>
                        </div>
                    </div>

                </div>
            </>}
            <ToastContainer />
        </div>
    )
}

export default VerificationScn